/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetBusinessLines$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBusinessLinesRequest = createAction<PayloadData<void>>('GET_BUSINESS_LINES__GET_BUSINESS_LINES__REQUEST');
export const getBusinessLinesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_BUSINESS_LINES__GET_BUSINESS_LINES__SUCCESS');
export const getBusinessLinesFailure = createAction<PayloadData<Error, void, true>>('GET_BUSINESS_LINES__GET_BUSINESS_LINES__FAILURE');

export const getBusinessLinesActions = [
    getBusinessLinesRequest,
    getBusinessLinesSuccess,
    getBusinessLinesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBusinessLines = (config?: GetBusinessLines$Config) => {
    return {
        CALL_API: {
            types: getBusinessLinesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/business-lines`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

